import { Model } from '@socrates/common';

export class SearchResponseInfo<T extends Model> {

	private _startPage = 0;                      // page index of starting page (this contains num-desired-pages pages)
	private _totalPages = 0;
	private _rows: T[] = null;
	private _pageSize = 0;
	private _totalResults = 0;

	constructor(startPage = 0, totalResults = 0, pageSize = 0, rows: T[] = null) {
		this._startPage = startPage;
		this._totalResults = totalResults;
		this._totalPages = Math.floor(((totalResults + pageSize - 1) / pageSize));
		this._pageSize = pageSize;
		this._rows = rows;
	}

	get startPage(): number {
		return this._startPage;
	}

	get totalPages(): number {
		return this._totalPages;
	}

	get rows(): T[] {
		return this._rows;
	}

	set rows(newRows: T[]) {
		this._rows = newRows;
		this._totalPages = Math.floor(((this.totalResults + this.pageSize - 1) / this.pageSize));
	}

	get pageSize(): number {
		return this._pageSize;
	}

	set pageSize(newPageSize: number) {
		this._pageSize = newPageSize;
		this._totalPages = Math.floor(((this.totalResults + this.pageSize - 1) / this.pageSize));
	}

	get totalResults(): number {
		return this._totalResults;
	}

	set totalResults(newTotalResults: number) {
		this._totalResults = newTotalResults;
		this._totalPages = Math.floor(((this.totalResults + this.pageSize - 1) / this.pageSize));
	}
}
